:host(.gxg--disabled) .form-element,
:host(.gxg--disabled.form-element) {
  pointer-events: none;
  background-color: var(--gxg-background-color--disabled) !important;
  color: var(--gxg-color--disabled) !important;
  border-color: var(--gxg-border-color--disabled) !important;
  cursor: default !important;
}

:host {
  display: block;
  cursor: pointer;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  font-family: var(--font-family-primary);
  font-size: var(--font-size-sm);
  background-color: var(--color-background);
  color: var(--color-on-background);
  opacity: 1;
  overflow: hidden;
}
:host .container {
  display: flex;
  align-items: center;
  padding: var(--spacing-comp-00) var(--spacing-comp-01);
  width: 100%;
  height: var(--gxg-list-item-height);
  box-sizing: border-box;
  /*items with icon are this tall*/
}
:host gxg-icon {
  flex-shrink: 0;
}

.description {
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

:host(.no-icon) .container {
  padding-left: var(--spacing-comp-02);
}

:host([hidden]) {
  display: none;
}

:host(.display-none) {
  display: none;
}

:host(:hover) {
  background-color: var(--gxg-background-color--hover);
}

:host([selected]) {
  background-color: var(--gxg-background-color--selected);
  color: var(--gxg-color--selected);
}

:host([selected]:hover) {
  background-color: var(--gxg-background-color--selected-hover);
}

/*********************************************
LARGE VERSION (html tag has 'gxg-large' class)
**********************************************/
:host(.large) {
  font-size: var(--font-size-lg);
  min-height: auto;
}
:host(.large) gxg-icon {
  margin-right: var(--spacing-comp-01);
}